export default "__VITE_ASSET__D2wcN3oz__"